import { RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TMeeting } from '@/common/basis/types/database/tmeeting';
import { openSummary } from '@/common/utils/window/webview';

function App(props: { item: TMeeting.Data; setIsOpen: (isOpen: boolean) => void }) {
  const item = props.item;
  const setIsOpen = props.setIsOpen;
  const roomName = useMemo(() => item?.roomName, [item?.roomName]);
  const existRecordFile = useMemo(() => item?.existRecordFile, [item?.existRecordFile]);
  const recordDuration = useMemo(() => item?.recordDuration ?? 0, [item?.recordDuration]);
  const roomId = useMemo(() => item?.roomId ?? '', [item?.roomId]);
  const roomSid = useMemo(() => item?.roomSid ?? '', [item?.roomSid]);
  const { t } = useTranslation();

  const formatStr = useMemo(() => {
    if (recordDuration < 60 * 1000) {
      return t('S', { sec: dayjs.duration(recordDuration).format('ss') });
    } else if (recordDuration < 60 * 60 * 1000) {
      return t('MS', {
        min: dayjs.duration(recordDuration).format('mm'),
        sec: dayjs.duration(recordDuration).format('ss'),
      });
    }

    return t('HMS', {
      hour: dayjs.duration(recordDuration).format('HH'),
      min: dayjs.duration(recordDuration).format('mm'),
      sec: dayjs.duration(recordDuration).format('ss'),
    });
  }, [recordDuration]);

  return existRecordFile ? (
    <div className='mb-3 cursor-pointer overflow-hidden rounded-xl bg-[#fff] p-3 py-4'>
      <div>
        <span>{t('recording')}</span>
      </div>
      <div
        className='flex items-center justify-start overflow-hidden pt-2'
        onClick={() => {
          openSummary({ roomId, roomSid });
          setIsOpen(false);
        }}
      >
        <div className='pr-3'>
          <img className='block h-9 w-9' src={require('@/common/basis/assets/summary_icon.png')} />
        </div>
        <div className='flex flex-1 flex-col justify-center'>
          <div>
            <span>
              {t('cloudRecording')}
              {roomName}
            </span>
          </div>
          <div className='mt-1 text-[12px] text-[#888]'>{dayjs.duration(recordDuration).format(formatStr)}</div>
        </div>
        <div>
          <RightOutlined className='text-[#888]' />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}

export default App;
